<script setup lang="ts">
import ListSlug from "@/components/lists/list-game-slug.vue";

defineProps<{
  ownerId: string;
}>();
</script>

<template>
  <section class="tab-slug">
    <div class="content">
      <list-slug :owner-id="ownerId" :type="null" />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.tab-slug {
  display: flex;
  flex-direction: column;
  padding-block: 1rem;
  gap: 1rem;

  .content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
}

@media screen and (max-width: 1024px) {
  .tab-slug {
    .content {
      padding-inline: 0;
    }
  }
}
</style>
